const signalR = require('@microsoft/signalr')

export function signalRCoreConnect (app, url, onReceive, ticket) {
  try {
    let connection = new signalR.HubConnectionBuilder()
      .withUrl(url)
      .configureLogging(signalR.LogLevel.Information)
      .build()
    let start = function () {
      connection.start().then(function () {
        connection.invoke('Subscribe', app, ticket)
        // eslint-disable-next-line no-console
        console.log('New SignalR Connected.')
      })
    }
    connection.on('ReceiveMessage', function (message) {
      let div = document.createElement('div')
      div.innerText = message
      let encodedMsg = div.innerHTML
      onReceive(encodedMsg)
    })
    connection.onclose(start)
    start()
    return connection
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err)
    return null
  }
}
